export const PUNTOS_VENTA_PARTICIPANTES = [
  ['MCKIO', 'TUCUMAN'],
  ['NATALY', 'SANTIAGO DEL ESTERO'],
  ['AUTOSERVICIOS CAPO', 'TUCUMAN'],
  ['EL PUESTO', 'TUCUMAN'],
  ['EL MARQUES', 'TUCUMAN'],
  ['DRAXXO', 'SANTA FE'],
  ['SAY NO MORE', 'SANTA FE'],
  ['MARKET YA', 'SANTA FE'],
  ['PINGÜINO', 'SANTA FE'],
  ['727', 'CORDOBA'],
  ['ALTO TEJEDA', 'CORDOBA'],
  ['PUNTO G', 'CORDOBA'],
  ['MULTIMARKET', 'CORDOBA'],
  ['DRINKS', 'CORDOBA'],
  ['TODO', 'BARILOCHE'],
  ['DINASTIA', 'RIO NEGRO'],
  ['AXION BARILOCHE', 'BARILOCHE'],
  ['MERCADO DEL LAGO', 'RIO NEGRO'],
  ['COMERCIAL NEUQUINA', 'RIO NEGRO'],
  ['AMELIA', 'RIO NEGRO'],
  ['ECO MARKET', 'RIO NEGRO'],
  ['RIO NAHUEVE SHELL LA COLONIA', 'RIO NEGRO'],
  ['PUMA GLOBAL OIL', 'RIO NEGRO'],
  ['KIOSCOS YES', 'MENDOZA'],
  ['KIOSCOS KIO BOX', 'MENDOZA'],
  ['AS PRET', 'MENDOZA'],
  ['CENTRAL DE BEBIDAS', 'MENDOZA'],
  ['KIOSKOS ONE STOP', 'MENDOZA'],
];
